// import node module libraries
import React, { Fragment, useEffect, useState } from 'react';
import { Card, Col, Container, Nav, Navbar, Row } from 'react-bootstrap';
import { Link, useLocation, useParams } from 'react-router-dom';
import ProfileBackground from 'assets/images/background/profile-bg.jpg';

// import routes file
// import utility file
import SalledeclasseService from '../../services/SalledeclasseService';
import EleveService from '../../services/EleveService';
import AnneescolaireService from '../../services/AnneescolaireService';

const SalledeclasseProfileLayout = (props) => {
	const location = useLocation();
	const [eleves, setEleves] = useState([]);
	const [salledeclasse, setSalledeclasse] = useState(null);
	const { id } = useParams();

	useEffect(() => {
		const fetchSalledeclasse = async () => {
			try {
				const response = await SalledeclasseService.getSalledeclasse(id);
				setSalledeclasse(response.data);
			} catch (error) {
				console.error('Error fetching salle de classe data', error);
			}
		};

		fetchSalledeclasse();
	}, [id]);

	useEffect(() => {
		const fetchCurrentSchoolYear = async () => {
			try {
				const schoolYear = await AnneescolaireService.getCurrentAnneescolaire();

				// Maintenant, appelez fetchEleves ici après avoir défini currentSchoolYear
				await fetchEleves(schoolYear.data.id);
			} catch (error) {
				console.error(
					"Erreur lors de la récupération de l'année scolaire en cours:",
					error
				);
				alert(
					`Erreur lors de la récupération de l'année scolaire en cours. Détails de l'erreur : ${error.message}`
				);
			}
		};

		const fetchEleves = async (anneeScolaireId) => {
			try {
				const response = await EleveService.getAllEleves(parseInt(id));
				// filter eleves who belong to the current class
				const filteredEleves = response.filter(
					(eleve) => eleve.anneescolaire === anneeScolaireId
				);
				setEleves(filteredEleves);
			} catch (error) {
				console.error('Error fetching eleves data', error);
			}
		};

		fetchCurrentSchoolYear();
	}, [id]);

	function formatIntituleClasse(value) {
		return value.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
	}

	return (
		<Fragment>
			<section className="pt-5 pb-5">
				<Container>
					{salledeclasse && (
						<>
							{/* User info */}
							<Row className="align-items-center">
								<Col xl={12} lg={12} md={12} sm={12}>
									<div
										className="pt-16 rounded-top-md"
										style={{
											background: `url(${ProfileBackground})`,
											backgroundRepeat: 'no-repeat',
											backgroundSize: 'cover'
										}}
									>
										{' '}
									</div>
									<Card className="px-4 pt-2 pb-4 rounded-0 rounded-bottom shadow-sm">
										<div className="d-flex align-items-end justify-content-between  ">
											<div className="d-flex align-items-center">
												<div className="lh-1">
													<h3 className="mb-0 text-uppercase">
														{formatIntituleClasse(
															salledeclasse.intitule_classe
														).toUpperCase() || ''}{' '}
														({eleves.length})
													</h3>
												</div>
											</div>
											<div>
												<Link
													to="/locaux/classes"
													className={`btn btn-outline-dark btn-sm mt-3 d-none d-md-block`}
												>
													Retour à la liste des salles de classe
												</Link>
											</div>
										</div>
									</Card>
								</Col>
							</Row>

							{/* Content */}
							<Row className="mt-0 mt-md-4">
								<Col lg={3} md={4} sm={12}>
									<Navbar
										expand="lg"
										className="navbar navbar-expand-md navbar-light shadow-sm mb-4 mb-lg-0 sidenav"
									>
										<Link
											className="d-xl-none d-lg-none d-md-none text-inherit fw-bold fs-5 float-start py-1"
											to="#"
										>
											Menu
										</Link>
										<Navbar.Toggle
											aria-controls="basic-navbar-nav"
											className="p-0 focus-none border-0"
											label="Responsive Menu"
										>
											<span
												className="navbar-toggler d-md-none icon-shape icon-sm rounded bg-primary p-0 text-white float-end"
												data-bs-toggle="collapse"
												data-bs-target="#sidenav"
												aria-controls="sidenav"
												aria-expanded="false"
												aria-label="Toggle navigation"
											>
												<span className="fa-solid fa-menu"></span>
											</span>
										</Navbar.Toggle>

										<Navbar.Collapse id="basic-navbar-nav">
											<Nav
												className="me-auto flex-column"
												as="ul"
												activeKey="0"
											>
												<Nav.Item className="navbar-header" as="li">
													Salle de classe
												</Nav.Item>
												<Nav.Item as="li">
													<Link
														className={`nav-link ${
															location.pathname ===
															`/locaux/classes/${salledeclasse?.id}/eleves`
																? 'active'
																: ''
														}`}
														to={`/locaux/classes/${salledeclasse?.id}/eleves`}
													>
														<i className="fa-solid fa-users nav-icon"></i>
														Elèves
													</Link>
												</Nav.Item>
												<Nav.Item as="li">
													<Link
														className={`nav-link ${
															location.pathname ===
															`/locaux/classes/${salledeclasse?.id}`
																? 'active'
																: ''
														}`}
														to={`/locaux/classes/${salledeclasse?.id}`}
													>
														<i className="fa-solid fa-chalkboard-user nav-icon"></i>
														Assigner un enseignant
													</Link>
												</Nav.Item>
												<Nav.Item as="li">
													<Link
														className={`nav-link ${
															location.pathname ===
															`/locaux/classes/${salledeclasse?.id}/eleves/print`
																? 'active'
																: ''
														}`}
														to={`/locaux/classes/${salledeclasse?.id}/eleves/print`}
													>
														<i className="fa-solid fa-print nav-icon"></i>
														Imprimer la liste des elèves
													</Link>
												</Nav.Item>
											</Nav>
										</Navbar.Collapse>
									</Navbar>
								</Col>

								<Col lg={9} md={8} sm={12}>
									{props.children}
								</Col>
							</Row>
						</>
					)}
				</Container>
			</section>
		</Fragment>
	);
};
export default SalledeclasseProfileLayout;
